import { queryOptions, useQuery } from '@tanstack/react-query';
import { getValidated } from '@shared/api';
import { dashboardKeys } from './keys';
import { DashboardResponseSchema, HomeSummaryResponseSchema } from './schemas';
import { toDashboardSummary, toHomeSummary } from './mappers';
import type { HomeSummaryFilter } from '../model/types';

/**
 * The logged-in user's dashboard summary (`GET /api/v1/dashboard`). Mapping in `select` keeps the
 * DTO out of components — they only see the domain `DashboardSummary`.
 */
export const dashboardQueryOptions = queryOptions({
  queryKey: dashboardKeys.all(),
  queryFn: () => getValidated('api/v1/dashboard', DashboardResponseSchema),
  select: toDashboardSummary,
});

export function useDashboard() {
  return useQuery(dashboardQueryOptions);
}

/** Home summary for the dashboard KPI tiles + Spend Mix chart. */
export function useHomeSummary(filter: HomeSummaryFilter, fromDate?: string, toDate?: string) {
  const params: Record<string, string> = { filter };
  if (filter === 'custom' && fromDate && toDate) {
    params.from_date = fromDate;
    params.to_date = toDate;
  }
  return useQuery({
    queryKey: dashboardKeys.homeSummary(filter, fromDate, toDate),
    queryFn: () => getValidated('api/v1/dashboard/home-summary', HomeSummaryResponseSchema, params),
    select: toHomeSummary,
    enabled: filter !== 'custom' || (!!fromDate && !!toDate),
  });
}
